/**
 * Os ícones da Ruth: SVG de traço 1.8 numa grade de 24, sem emoji.
 *
 * São os mesmos desenhos dos mockups em docs/design. A cor vem de
 * `currentColor`, então quem manda é o CSS — e o tema escuro funciona sozinho.
 */

type Props = {
  nome: NomeDeIcone
  tamanho?: number
  className?: string
}

export type NomeDeIcone =
  | 'sino'
  | 'remedio'
  | 'check'
  | 'calendario'
  | 'carrinho'
  | 'seta'
  | 'protegido'
  | 'casa'
  | 'microfone'
  | 'mais'
  | 'camera'
  | 'enviar'
  | 'parar'
  | 'somar'
  | 'gota'
  | 'lixeira'
  | 'engrenagem'
  | 'pessoa'
  | 'voltar'

const CAMINHOS: Record<NomeDeIcone, React.ReactNode> = {
  sino: (
    <>
      <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </>
  ),
  remedio: (
    <>
      <rect x="3" y="8" width="18" height="8" rx="4" transform="rotate(-45 12 12)" />
      <path d="m9 9 6 6" />
    </>
  ),
  check: <path d="m5 12 4.5 4.5L19 7" />,
  calendario: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </>
  ),
  carrinho: (
    <>
      <path d="M3 4h2l2.4 11h11L21 7H6" />
      <circle cx="9" cy="20" r="1.4" />
      <circle cx="17" cy="20" r="1.4" />
    </>
  ),
  seta: <path d="m9 6 6 6-6 6" />,
  protegido: (
    <>
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </>
  ),
  casa: (
    <>
      <path d="M3 11 12 3l9 8" />
      <path d="M5 10v10h14V10" />
    </>
  ),
  microfone: (
    <>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
    </>
  ),
  mais: (
    <>
      <circle cx="5" cy="12" r="1.4" />
      <circle cx="12" cy="12" r="1.4" />
      <circle cx="19" cy="12" r="1.4" />
    </>
  ),
  camera: (
    <>
      <path d="M4 8h3l2-3h6l2 3h3v11H4z" />
      <circle cx="12" cy="13" r="3.2" />
    </>
  ),
  enviar: <path d="M5 12h13m-6-7 7 7-7 7" />,
  parar: <rect x="7" y="7" width="10" height="10" rx="2.5" />,
  somar: <path d="M12 5v14M5 12h14" />,
  gota: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6 7 7M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4" />
    </>
  ),
  lixeira: (
    <>
      <path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" />
      <path d="M10 11v6M14 11v6" />
    </>
  ),
  engrenagem: (
    <>
      <circle cx="12" cy="12" r="3.2" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9 7 7M17 17l2.1 2.1M4.9 19.1 7 17M17 7l2.1-2.1" />
    </>
  ),
  pessoa: (
    <>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </>
  ),
  voltar: <path d="M15 6l-6 6 6 6" />,
}

export function Icone({ nome, tamanho = 20, className }: Props) {
  return (
    <svg
      className={className}
      width={tamanho}
      height={tamanho}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {CAMINHOS[nome]}
    </svg>
  )
}
